import React from 'react';
import { Select } from '@meitu/saas-ui';
import { SizeUnitType } from '@meitu/saas-editor-core/es/utils/unit-kit';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import './index.less';

const { Option } = Select;

const SelectOpt = ({
    disabled = false,
    unit,
    setUnit,
}: {
    disabled?: boolean;
    unit: SizeUnitType;
    setUnit: (unit: SizeUnitType) => void;
}) => {
    const { $t } = useLocaleStore();

    return (
        <div className="c-adjust-size-panel-unit">
            <div className="c-adjust-size-panel-unit__title">{$t((v) => v.panel.backgroundPanel.unit)}</div>
            <Select
                popupClassName="c-adjust-size-panel-select"
                defaultValue={SizeUnitType.px}
                style={{ width: 50 }}
                onChange={(val: any) => {
                    setUnit(val);
                    editor.services.editor.setUnit(val);
                }}
                disabled={disabled}
                value={unit}
                suffixIcon={<IconFont name="ChevronDownBlack" fontSize={10} color="var(--content-input-label)" />}
            >
                <Option key={SizeUnitType.px} value={SizeUnitType.px}>
                    {SizeUnitType.px}
                </Option>
                <Option key={SizeUnitType.mm} value={SizeUnitType.mm}>
                    {SizeUnitType.mm}
                </Option>
                <Option key={SizeUnitType.cm} value={SizeUnitType.cm}>
                    {SizeUnitType.cm}
                </Option>
            </Select>
        </div>
    );
};
export default React.memo(SelectOpt);
